/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BudgetViewSummaryModel {
    getFixupPrototypeFunction() { return BudgetViewSummaryModel.fixupPrototype; }

    static newInstance(model: Partial<BudgetViewSummaryModel>): BudgetViewSummaryModel {
        let obj = Object.assign(new BudgetViewSummaryModel(), model);
        BudgetViewSummaryModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BudgetViewSummaryModel>): BudgetViewSummaryModel {
        if (!model) return null;
        return BudgetViewSummaryModel.newInstance(<BudgetViewSummaryModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BudgetViewSummaryModel) {
        if (!obj) return;

        models.BudgetViewSummaryModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BudgetViewSummaryModel): boolean {
        Object.setPrototypeOf(obj, BudgetViewSummaryModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.budget_details) {
            models.BudgetDetailsModel.fixupPrototype(this.budget_details);
        }
        if (this.budget_amount) {
            models.BudgetAmountModel.fixupPrototype(this.budget_amount);
        }
        if (this.threshold_details) {
            for (let val of this.threshold_details) {
                models.BudgetThresholdViewModel.fixupPrototype(val);
            }
        }
    }

    /**
     * budget details
     */
    budget_details: models.BudgetDetailsModel;

    /**
     * budget amount data
     */
    budget_amount: models.BudgetAmountModel;

    /**
     * threshold details
     */
    threshold_details: Array<models.BudgetThresholdViewModel>;

}
